import {ChangeEvent, Dispatch, FC, SetStateAction, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {createClaimDocumentsService} from '../../../../services/claim.service'
import {useCentral} from '../../../../../../hooks/useCentral'
import {TabCentralModel} from '../../../../../../models'
import {ShowSnackBar} from '../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getClaimDocuments: () => void
}

const ModalClaimDocuments: FC<Props> = ({show, setShow, getClaimDocuments}) => {
  const handleClose = () => {
    setShow(false)
  }

  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState('')
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const {currentTabItem, changeCurrentTabItem} = useCentral()

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setError('')
  }

  const handleUpload = async () => {
    try {
      if (file) {
        setError('')

        const formData = new FormData()
        formData.append('file', file)
        const obj: TabCentralModel = {
          ...currentTabItem,
          loadingTable: false,
        }
        changeCurrentTabItem(obj)
        const response = await createClaimDocumentsService(formData, currentTabItem?.idToEdit) // Use the service to upload the file
        if (!response.data.error) {
          handleClose()
          getClaimDocuments()
          const obj2: TabCentralModel = {
            ...currentTabItem,
            loadingTable: true,
          }
          changeCurrentTabItem(obj2)
          ShowSnackBar('Documento cargado correctamente')
        } else {
          setShow(true)
          //   const error = response?.data?.data || []
          // setResponse(error)
          ShowSnackBar(response.data.message, 'error')
        }
      } else {
        setError('Este campo es requerido')

        console.error('No file selected.')
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = '' // Borra la selección de archivo
      }
      setFile(null)
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Adjuntar Archivo</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
              <label className='required form-label'>Examinar</label>
              <div className='input-group input-group-sm'>
                <input
                  className='form-control'
                  type='file'
                  id='formFileRoom'
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
              </div>
              {error && <p className='error-message'>{error?.toString()}</p>}
            </div>

            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleUpload}>
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalClaimDocuments}
